import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../../lib/utils';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  function Input({ className, ...props }, ref) {
    return (
      <input
        ref={ref}
        className={cn(
          'flex h-10 w-full rounded-lg border border-border-strong bg-surface px-3 py-2 text-sm text-fg shadow-sm',
          'placeholder:text-muted',
          'focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-brand',
          'disabled:cursor-not-allowed disabled:opacity-60',
          'aria-[invalid=true]:border-danger aria-[invalid=true]:outline-danger',
          className,
        )}
        {...props}
      />
    );
  },
);
